import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsQuestionModel } from "src/app/models/widgets/widgets-question.model";

@Injectable({
  providedIn: 'root'
})
export class CloneFormService extends AbstractClone {

  constructor(private injector: Injector) {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
    let origForm = origWidget as WidgetsFormModel;

    // Retrieve from injector to avoid circular dependency
    const widgetsCloneService = this.injector.get(CloneService);

    if (!isDragNDrop) {
      // Cloning Question into Form
      const newForm = destWidget as WidgetsFormModel;
      // newForm = new WidgetsFormModel();
      CloneService.cloneLabelOverrides(origForm, newForm);
      origForm.children.forEach(childWidget => {
        widgetsCloneService.cloneFromJS(childWidget, newForm, false, isInsideQuestion, newForm.id);
      });
    } else {
      // Question dropped into Form / Column. Clone from TypeScript to TypeScript
      const newForm = destWidget as WidgetsFormModel;
      CloneService.cloneLabelOverrides(origForm, newForm);
      origForm.children.forEach(childWidget => {
        // Take care, it's the generic one here
        widgetsCloneService.cloneFromJS(childWidget, destWidget!, isDragNDrop, isInsideQuestion, newForm.id);
      });
    }
  }
}
